import { render } from "./BotonNotificarEmbargoPersonaComponent.vue?vue&type=template&id=03f0ce8b"
import script from "./BotonNotificarEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./BotonNotificarEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__